import FavoriteHeader from "./favorite-header";

export default FavoriteHeader;